import { useEffect, useId, useMemo, useState } from "react";
import { editorFileLabelClassName } from "../editor/editorStyles";

export default function FileInput({
	onChange,
	label,
	accept = "image/*",
	existingPreviewUrl = "",
}) {
	const inputId = useId();
	const [pickedFile, setPickedFile] = useState(null);

	const previewSrc = useMemo(() => {
		if (pickedFile instanceof File) {
			return URL.createObjectURL(pickedFile);
		}
		if (existingPreviewUrl && typeof existingPreviewUrl === "string") {
			return existingPreviewUrl;
		}
		return null;
	}, [existingPreviewUrl, pickedFile]);

	useEffect(() => {
		if (!previewSrc || !pickedFile) return undefined;
		return () => URL.revokeObjectURL(previewSrc);
	}, [previewSrc, pickedFile]);

	const handleChange = (event) => {
		const file = event.target.files?.[0] || null;
		setPickedFile(file);
		onChange(event);
	};

	const isImage = accept.includes("image");

	return (
		<div className="flex flex-col gap-3">
			<label htmlFor={inputId} className={editorFileLabelClassName}>
				<span className="font-Vazir-600 text-[13px] text-darkBlue/85">{label}</span>
				<span className="font-Vazir-400 text-[12px] text-darkBlue/50">
					{pickedFile?.name || "فایل جدید انتخاب کنید (در ویرایش اختیاری است)"}
				</span>
				<span className="inline-flex w-fit items-center justify-center rounded-[10px] bg-white px-4 py-2 font-Vazir-600 text-[13px] text-darkBlue shadow-sm ring-1 ring-darkBlue/15 transition hover:bg-lightCta/80">
					انتخاب فایل
				</span>
				<input
					id={inputId}
					type="file"
					accept={accept}
					onChange={handleChange}
					className="sr-only"
				/>
			</label>
			{isImage && previewSrc && (
				<div className="overflow-hidden rounded-[12px] border border-darkBlue/10 bg-white p-2">
					<img
						src={previewSrc}
						alt=""
						className="mx-auto max-h-40 w-auto max-w-full rounded-[8px] object-contain"
					/>
					<p className="mt-2 text-center font-Vazir-400 text-[12px] text-darkBlue/50">
						{pickedFile ? "پیش‌نمایش فایل جدید" : "تصویر فعلی"}
					</p>
				</div>
			)}
		</div>
	);
}
